import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ApiUrls, Doctypes } from '../apiurls';
import { LOCAL_STORAGE_KEYS, LocalStorageItemsService } from '../../services/local-storage-items.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hospitality-unit',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hospitality-unit.component.html',
  styleUrl: './hospitality-unit.component.scss',
   encapsulation: ViewEncapsulation.None 
})
export class HospitalityUnitComponent {
  marsha_code_list: any = [];
  selectedMarshaDetails: any = {};
   isProductPage = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private localStorageService: LocalStorageItemsService
  ) {
    this.localStorageService.getItem$(LOCAL_STORAGE_KEYS.USERSCOMPANIES).subscribe((data) => {
      this.marsha_code_list = data || [];
      // Resolved here, not in the constructor body: the list is what decides
      // whether a remembered property is still one this user has.
      this.restoreSelection();
    });
  }

  /**
   * Start on the property the user last chose.
   *
   * The choice was not kept anywhere, so every load fell back to the first
   * company and announced *that* to the rest of the app -- while the dropdown
   * showed something else. Screens listening for the property then reloaded
   * against the wrong one: the Workflow Requests list fetched JWMPG-01, then
   * this component announced CRT and the second answer overwrote the first.
   */
  private restoreSelection(): void {
    const names = (this.marsha_code_list || []).map((c: any) => c?.name);
    if (!names.length) return;
    let remembered: string | null = null;
    try {
      remembered = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.SELECTED_MARSHA) || 'null');
    } catch {
      remembered = null;
    }
    const chosen = names.includes(remembered) ? remembered : names[0];
    if (this.selectedValue === chosen) return;
    this.selectedValue = chosen;
    this.get_marsha_details();
  }

  // Manage label internally
  inputValue: string = '';

  // Output selected value if needed
  @Output() selectionChange = new EventEmitter<any>();

  selectedValue: string = '';
 ngOnInit() {
    this.checkRoute();
    // Optional: subscribe to route changes
    this.router.events.subscribe(() => {
      this.checkRoute();
    });
  }
  onSelectChange(event: any) {
    this.selectedValue = event.target.value;
    // Remembered, so the next load starts where the user left off rather than
    // on whichever company happens to be first.
    this.localStorageService.setItem(
      LOCAL_STORAGE_KEYS.SELECTED_MARSHA, this.selectedValue);
    this.get_marsha_details();
  }
  checkRoute() {
   this.isProductPage =
  this.router.url.includes('/home/products') ||
  this.router.url.includes('/home/settings');

  }
  get_marsha_details() {
    const selectedCode = this.selectedValue || this.marsha_code_list[0]?.name;

    this.http.get(ApiUrls.get_by_name, {
      params: {
        doctype: Doctypes.marsha_code,
        name: selectedCode,
      }
    }).subscribe((res: any) => {
      if (res?.message?.success) {
        this.selectedMarshaDetails = res?.message?.message || {};

        // Emit the selected marsha code and details to parent component
        const selectionData = {
          marshaCode: selectedCode,
          marshaDetails: this.selectedMarshaDetails,
          selectedValue: this.selectedValue
        };

        this.selectionChange.emit(selectionData);
      }
    });
  }
}
